import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { Types } from './types';

// ACTIONS
import { tiposChavePixSuccess, tiposChavePixFailure } from './actions';

function* tiposChavePixRequest() {
	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`dominios-crm/${CHANNEL}/tipos-chave-pix`,
		{},
	);

	if (response.status === 200) {
		yield put(tiposChavePixSuccess(response));
	} else {
		yield put(tiposChavePixFailure(response));
	}
}

export default all([
	takeLatest(Types.TIPOS_CHAVE_PIX_REQUEST, tiposChavePixRequest),
]);
